module.exports = __webpack_public_path__ + "static/banner-6-contact-us-29883485bf928e0ad78354e25f347076.jpg";